import { render } from "./OutgoingCall.vue?vue&type=template&id=01030c6e&scoped=true"
import script from "./OutgoingCall.vue?vue&type=script&lang=js"
export * from "./OutgoingCall.vue?vue&type=script&lang=js"

import "./OutgoingCall.vue?vue&type=style&index=0&id=01030c6e&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01030c6e"]])

export default __exports__